module.exports = __webpack_public_path__ + "img/bookshelf04.f4e776b8.jpg";